// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React, {memo} from 'react';

const CheckboxPartialIcon = () => (
    <svg
        width='18px'
        height='18px'
        viewBox='0 0 18 18'
    >
        <g
            id='Developer-Export'
            stroke='none'
            strokeWidth='1'
            fillRule='evenodd'
        >
            <g
                transform='translate(-298.000000, -1273.000000)'
                id='All-Team-Members'
            >
                <g transform='translate(245.000000, 698.000000)'>
                    <g
                        id='Channel-Administrators'
                        transform='translate(0.000000, 106.000000)'
                    >
                        <g
                            id='data-table/column-1'
                            transform='translate(11.000000, 86.000000)'
                        >
                            <g
                                id='row-checkbox---@all-@channel-Mentions'
                                transform='translate(0.000000, 375.000000)'
                            >
                                <g id='Stacked-Group'>
                                    <g
                                        id='data-table/1st/row-checkbox-label-base'
                                        transform='translate(25.000000, 5.000000)'
                                    >
                                        <g
                                            id='check-on-copy-11'
                                            transform='translate(14.000000, 0.000000)'
                                        >
                                            <path
                                                d='M19,3 C20.1,3 21,3.9 21,5 L21,19 C21,20.1 20.1,21 19,21 L5,21 C3.9,21 3,20.1 3,19 L3,5 C3,3.9 3.9,3 5,3 L19,3 Z M7,11 L7,13 L17,13 L17,11 L7,11 Z'
                                                id='checkbox---partial'
                                            />
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default memo(CheckboxPartialIcon);
